import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { eduTitle, eduList0, shopInEdu, eduList1, eduListAd, eduHardAd, promoteInEdu },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="170176" type="struct" title="教育标题" groupName="教育" content={eduTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="255869"
                    type="recommend"
                    title="教育列表1"
                    groupName="教育"
                    content={eduList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="195870"
                    type="recommend"
                    title="教育区电商"
                    groupName="教育"
                    content={shopInEdu}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="255870"
                    type="recommend"
                    title="教育列表2"
                    groupName="教育"
                    content={eduList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={eduListAd} />
                </Chip>
                <NoSSR>
                    <Ad content={eduHardAd} styleName={styles.dbox} />
                </NoSSR>
                {promoteInEdu && (
                    <Chip id="230196" type="struct" title="铺底推广" groupName="教育" content={promoteInEdu}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
